import { ArgsType, Field, Int } from '@nestjs/graphql'
import { BaseUpdateDto } from '../base/baseUpdate.dto'
import { CategoryIdInput } from '../category'

@ArgsType()
export class UpdateBookDto extends BaseUpdateDto<UpdateBookDto> {
  @Field(type => String, { nullable: true })
  title?: string

  @Field(t => String, { nullable: true })
  description?: string

  @Field(type => String, { nullable: true })
  penName?: string

  @Field(type => Int, { nullable: true })
  authorPenNameId?: number

  @Field(type => Int, { defaultValue: 0, nullable: true })
  penNameType?: number = 0

  @Field(type => String, { nullable: true })
  bookCover?: string

  @Field({ nullable: true })
  releaseDate?: Date

  @Field(type => String, { nullable: true })
  seriesName?: string

  @Field(type => Int, { nullable: true })
  seriesNumber?: number

  @Field(type => [CategoryIdInput], { nullable: true })
  categories?: CategoryIdInput[]

  @Field(type => String, { nullable: true })
  keywords?: string

  @Field(type => Int, { nullable: true })
  wordCount?: number

  @Field(type => Int, { nullable: true })
  audience?: number

  @Field(type => Int, { nullable: true })
  language?: number

  @Field(type => String, { nullable: true })
  linkAmazonAsin?: string

  @Field(type => String, { nullable: true })
  linkAmazonAsinPrint?: string

  @Field(type => String, { nullable: true })
  linkGoodreads?: string

  @Field(type => String, { nullable: true })
  linkBookbub?: string

  @Field(type => String, { nullable: true })
  linkBarnes?: string

  @Field(type => String, { nullable: true })
  linkGoogle?: string

  @Field(type => String, { nullable: true })
  linkKobo?: string

  @Field(type => String, { nullable: true })
  linkSmashwords?: string

  @Field({ nullable: true})
  smashwordsCouponCode?: string

  @Field(type => String, { nullable: true })
  linkITunes?: string

  @Field(type => String, { nullable: true })
  linkAudibleUs?: string

  @Field(type => String, { nullable: true })
  linkAudibleUk?: string

  @Field(type => String, { nullable: true })
  linkITunesAudio?: string

  @Field(type => String, { nullable: true })
  linkBarnesAudio?: string

  @Field(type => String, { nullable: true })
  linkGoogleAudio?: string

  @Field(type => String, { nullable: true })
  linkGoodreadsAudio?: string

  @Field(type => String, { nullable: true })
  linkKoboAudio?: string

  @Field({ nullable: true })
  linkBookbubAudio?: string

  @Field({ nullable: true })
  linkStoryGraph?: string

  @Field({ nullable: true })
  linkStoryGraphAudio?: string

  @Field(type => Int, { nullable: true })
  source?: number

  @Field(type => String, { nullable: true })
  pdfFile?: string

  @Field(type => Int, { nullable: true })
  pdfFileSizeBytes?: number

  @Field({ nullable: true })
  pdfSystemGenerated?: boolean

  @Field({ nullable: true })
  pdfFileDate?: Date

  @Field(type => String, { nullable: true })
  epubFile?: string

  @Field(type => Int, { nullable: true })
  epubFileSizeBytes?: number

  @Field(type => String, { nullable: true })
  epubPreviewFile?: string

  @Field({ nullable: true })
  epubSystemGenerated?: boolean

  @Field({ nullable: true })
  epubFileDate?: Date

  @Field({ nullable: true })
  generatedNewEpub?: boolean

  @Field({ nullable: true })
  epubFileFriendlyName?: string

  @Field({ nullable: true })
  pdfFileFriendlyName?: string

  @Field(t => Int, { nullable: true })
  awaitingBookFileFlag?: number
}
